import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Label } from "reactstrap"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import FileUpload from "components/Common/file-upload/file-upload.component"
import { providerPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import CancelModal from "components/CancelModal"
import SelectOptions from "components/SelectOptions"
import DeveloperService from "services/Admin/DeveloperService"
import ActivitiesService from "services/Provider/ActivitiesService"
import Select from "react-select";
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import LeadService from "services/Provider/LeadService"
import SalesRepsService from "services/Admin/SalesRepsService"
import { activityOptions } from "Enums/fixedData"
import SuccessModal from "components/SucessModal"
import {useSelector} from "react-redux"

const initialState = {
    title: "",
    // status: "",
    feedback: "",
    time: "",
    description: "",
    activity_type: null,
    date: "",
    selectedLead: null,
    location: ""

}

const UpdateDeveloperPage = (props) => {
    const leadId = props.match.params.leadId
    const id = props.match.params.id
    const leadService = new LeadService()
    const [formState, setFormState] = useState(initialState)
    const [modal, setModal] = useState(false)
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const activitiesService = new ActivitiesService()
    const currentday = new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? `0${(new Date().getMonth() + 1)}` : (new Date().getMonth() + 1)) + '-' + new Date().getDate()
    const [leadsOptions, setLeadOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const salesRep = useSelector(state => state.Auth.userId)

    const handleValidSubmit = (e, v) => {
        if (!formState.activity_type) {
            toast.error("Shall choose an active type")
            return
        } else if (!formState.selectedLead) {
            toast.error("Select Client Name")
            return
        } else {
            setLoading(true)

            const data = {
                type: "Deal",
               deal_id:id,
               title : formState.title,
               activity_type: formState.activity_type.value,
               description : formState.description,
               feedback : formState.feedback,
               date : formState.date,
               time : formState.time,

             }
            if (formState.activity_type.value === "Visit") data["location"] = formState.location
 
            activitiesService.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    // toast.success("Activity Added Successfully")
                    setShowSuccessModal(true)
                    // props.history.goBack()
                } else {
                    setLoading(false)
                }
            })
        }

    }

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        if (leadId) {
            if(salesRep){
            leadService.getDropDown(salesRep).then(res => {
                // const lead = res.data.find(item => item.id === parseInt(leadId))
               

                const newOptions = res.data.map(item => {
                    return {
                        label: `${item.id} / ${item.name}`,
                        value: item.id
                    }
                })
                setLeadOptions(newOptions)
                const lead = newOptions.find(item => item.value === parseInt(leadId))
               if(lead?.value){
                setFormState((formState) => ({
                    ...formState,
                    selectedLead: { ...lead
                    }
                }))
               }
            })
        }
    }

    }, [leadId,salesRep])


    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Add Activity</title>
                </MetaTags>
                <Container fluid>
                    <h4>
                        {/* <button className="p-0 m-0 border-0 bg-light"
              onClick={() => {
                setFormState(initialState)
                props.history.push(`${providerPrefix}/leads`)
              }}>
              <i className="fa fa-arrow-left text-primary me-2"></i>
            </button> */}
                        Add Activity
          </h4>
                    <AvForm
                        className='form-horizontal'
                        onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                        }}>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='title'
                                                label="Activity Title"
                                                className='form-control'
                                                placeholder='Type Activity Title'
                                                required
                                                errorMessage="This field is required"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.title}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <label>Client Name</label>
                                        <Select
                                            placeholder='Select'
                                            options={leadsOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedLead: data })}
                                            value={formState.selectedLead}
                                            setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Activity Type </label>
                                        <Select
                                            placeholder='Select'
                                            options={activityOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, activity_type: data })}
                                            value={formState.activity_type}
                                        // setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    {formState.activity_type ?.value === "Visit" ?
                                        <Col md={6}>
                                            <div className='mb-3'>
                                                <AvField
                                                    name='location'
                                                    label="Location"
                                                    className='form-control'
                                                    placeholder='Type Location'
                                                    required
                                                    onChange={(e) => handleFieldChange(e)}
                                                    bsSize="lg"
                                                    value={formState.location}
                                                />
                                            </div>
                                        </Col> : null
                                    }
                                    <Col md={12}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='description'
                                                label="Description"
                                                placeholder='Type Description'
                                                className='form-control'
                                                type="textarea"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.description}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='date'
                                                label="Date"
                                                className='form-control'
                                                required
                                                errorMessage="This field is required"
                                                type='date'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.date}
                                                min="2022-01-01"

                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='time'
                                                label="Time"
                                                className='form-control'
                                                placeholder='Type Time'
                                                required
                                                errorMessage="This field is required"
                                                type='time'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.time}
                                            />
                                        </div>
                                    </Col>
                                    {/* <Col md={6}>
                                        <Label className='p-0 m-0 font-size-13'>
                                            Status
                                       </Label >
                                        <AvRadioGroup className="mt-2" required inline name="status" value={formState.status} onChange={handleFieldChange} >
                                            <AvRadio label="Contacted" value="Contacted" />
                                            <AvRadio label="UnReachable" value="UnReachable" />
                                        </AvRadioGroup>
                                    </Col> */}
                                    <Col md={12}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='feedback'
                                                label="feedback"
                                                placeholder='Type Feedback'
                                                className='form-control'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                type="textarea"
                                                value={formState.feedback}
                                                required
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-between pb-4">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btnUpload btnHeight px-4"
                                    onClick={() => {
                                        setModal(true)
                                    }}
                                    size={"lg"}>
                                    Cancel
                  </button>
                            </Col>
                            <Col>
                                <button
                                    type='submit'
                                    className="btn btn-success btnHeight px-4 float-end"
                                    size={"lg"}
                                    disabled={loading ? true : false}
                                >
                                    Submit
                </button>
                            </Col>
                        </Row>
                        <CancelModal modal={modal}
                            setModal={setModal}
                            goBackHandler={() => props.history.goBack()}
                        />
                    </AvForm>
                    {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Add Activity"}
                        subtitle={""}
                        message={"New Activity Added Successfully"}
                        onClick={() => props.history.goBack()} />}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UpdateDeveloperPage
